import {
  Box,
  Grid,
  IconButton,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import Modal from "components/Modal";
import QrReader from "modern-react-qr-reader";
import { ScanCode } from "assets/Icon";
import Select from "components/Select";
import Textarea from "components/Textarea";
import { useFormContext } from "react-hook-form";
import useIsMobileView from "hooks/useIsMobileView";
import { useState } from "react";

function WithdrawNetworkAddress({
  selectedNetwork,
  withdrawInitial,
  currentNetworkFields,
}) {
  const isMobileView = useIsMobileView();
  const theme = useTheme();
  const [showQrCodeScanner, setShowQrCodeScanner] = useState(false);

  const { watch, setValue } = useFormContext();
  const typeId = watch("typeId");
  const address = watch("address");
  const networkId = watch("networkId");
  const isDigital = watch("isDigital");

  const internalTypeId = withdrawInitial?.lisType?.find(
    (type) => type.name === "Internal"
  )?.id;

  return (
    <>
      {isDigital && (
        <Grid item xs={12}>
          <Typography variant="h6" color="text.main">
            Network
          </Typography>

          <Select
            items={selectedNetwork}
            value={networkId}
            itemText="networkName"
            itemValue="networkId"
            dir="ltr"
            onChange={(e) => setValue("networkId", e.target.value)}
          />
        </Grid>
      )}

      {currentNetworkFields?.isHaveAddress && (
        <Grid item xs={12}>
          <LabelWithButton>
            <Typography variant="h6" color="text.main">
              Address
            </Typography>

            {isMobileView && (
              <IconButton
                color="text"
                onClick={() => setShowQrCodeScanner(true)}
              >
                <ScanCode color={theme.palette.secondary.main} />
              </IconButton>
            )}
          </LabelWithButton>

          <TextareaStyled
            placeholder={
              typeId === internalTypeId && "کد کاربر مورد نظر را وارد کنید"
            }
            value={address}
            onChange={(e) => {
              setValue("address", e.target.value);
            }}
          />
        </Grid>
      )}

      {showQrCodeScanner && (
        <Modal
          open={showQrCodeScanner}
          onClose={() => setShowQrCodeScanner(false)}
          title="Qr Code Scanner"
        >
          <QrReader
            delay={300}
            ViewFinder={() => <ViewFinder />}
            onScan={(result) => {
              if (!!result) {
                setValue("address", result);
                setShowQrCodeScanner(false);
              }
            }}
            facingMode={"environment"}
          />
        </Modal>
      )}
    </>
  );
}

const ViewFinder = styled(Box)(() => ({
  width: "100%",
  height: "300px",
}));

const TextareaStyled = styled(Textarea)(({ theme }) => ({
  "&::placeholder": { textAlign: "right" },
  "&:focus": {
    border: `1px solid ${theme.palette.info.lightest}`,
  },
}));

const LabelWithButton = styled(Box)(() => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "space-between",
}));

export default WithdrawNetworkAddress;
